module.exports = __webpack_public_path__ + "img/mobile-title.6e059c66.webp";